import styled from "styled-components";
import PropTypes from "prop-types";
import {
  desktopMarginVal,
  desktopMarginsCutoff,
  mobileMarginVal,
} from "../../styleConstants";

const FooterWrapper = styled.div`
  // fixed-size flex item, outside SlideInContent's scroll region
  // always docked at the bottom, never scrolls away, moves with Slide as a normal child (no position trick needed).
  flex-shrink: 0;
  background: white;
  border-top: 1px solid #e5e5e5;

  margin-left: ${mobileMarginVal}px;
  margin-right: ${mobileMarginVal}px;
  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    margin-left: ${desktopMarginVal}px;
    margin-right: ${desktopMarginVal}px;
  }
`;

const SlideInFooter = ({ footer }) => <FooterWrapper>{footer}</FooterWrapper>;

SlideInFooter.propTypes = {
  footer: PropTypes.element,
};

export default SlideInFooter;
